<div
  [class]="'px-4 pt-2 pb-4 bg-white shadow form-card-wrapper-component ' + (props.classList ?? '')"
  [attr.id]="props.id ?? null"
>
  @if (props.title) {
    <h1 class="mt-2 fw-light">{{ props.title }}</h1>
  }
  @if (props.summary) {
    <div [innerHTML]="props.summary"></div>
  }
  <ng-container #fieldComponent />
</div>
